import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export interface SummaryActionPayload {
  section: string
  chartName: string
  summary: string
}

export interface Summary {
  section?: string
  summaries?: Record<string, string>
  generateSummary?: boolean
}

const initialState: Summary = {}

const summarySlice = createSlice({
  name: 'summaries',
  initialState,
  reducers: {
    setSummary(state, action: PayloadAction<SummaryActionPayload>) {
      const { section, chartName, summary } = action.payload
      const isSummaryExist = state.summaries?.[chartName]

      if (!isSummaryExist) {
        state.section = section
        state.summaries = {
          ...(state.summaries ?? {}),
          [chartName]: summary,
        }
      }
    },
    generateSummary(state: Summary) {
      state.generateSummary = true
    },
    clearSummaries() {
      return initialState
    },
  },
})

export const { setSummary, generateSummary, clearSummaries } = summarySlice.actions

export default summarySlice.reducer
